import { render, staticRenderFns } from "./RefillBrandWarning.vue?vue&type=template&id=60efda4e&"
import script from "./RefillBrandWarning.vue?vue&type=script&lang=js&"
export * from "./RefillBrandWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports